import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
    name: 'dateWithTime',
    standalone: false
})
export class DateWithTimePipe implements PipeTransform {
  transform(value: string | Date | null): string {
    const dateTime = dayjs(value);
    return dateTime.format('MM/DD/YYYY h:mm A');
  }
}
